module.exports = __webpack_public_path__ + "img/733df1f.svg";